import { MicrositeCustomTheme, MicrositeTheme } from 'types';
import { baseTheme } from '../baseTheme';

// ==================================
// BEGIN CUSTOM THEMING FOR MICROSITE
// ==================================

const customTheme: MicrositeCustomTheme = {
  name: 'StarryTheme',
  code: 'Starry',
  colors: {
    headerBackground: '#636CB1',
    headerText: '#FFFFFF',
    headerBorder: '#FFFFFF',
    background: '#FFFFFF',
    footerBackground: '#CBD0F9',
    footerText: '#373755',
    footerBorder: '#FFFFFF',
    progressBar: '#71E8DC',
  },
  logoSize: {
    width: '168px',
    height: '40px',
  },
  baseColors: {
    link: '#3C3C57',
    cta: '#4D5399',
    hover: '#3C3C57',
  },
};

// ==================================
// END CUSTOM THEMING FOR MICROSITE
// ==================================

const mergedTheme = Object.assign(baseTheme, {
  colors: {
    ...baseTheme.colors,
    ...customTheme.baseColors,
  },
});

export const StarryTheme: MicrositeTheme = {
  ...mergedTheme,
  customTheme,
};
